// src/pages/seo/components/AiControls.tsx

import React from 'react';
type Props = { loading?: boolean; onRegenerate: () => void; onUse: () => void };
export function AiControls({ loading, onRegenerate, onUse }: Props) {
  return (
    <div className="flex items-center gap-2 mt-2">
      <button className="border rounded px-2 py-1" onClick={onRegenerate} disabled={loading}>{loading? 'Generating�':'Regenerate'}</button>
      <button className="border rounded px-2 py-1" onClick={onUse} disabled={loading}>Use AI suggestion</button>
    </div>
  );
}